function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_69",
  "data-name": "Group 69",
  transform: "translate(-6950.5 -4009)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  width: 28,
  height: 28,
  transform: "translate(6950.5 4009)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_68",
  "data-name": "Group 68"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_39",
  "data-name": "Path 39",
  d: "M6972.913,4015.281a20.025,20.025,0,0,0-4.942-1.533.075.075,0,0,0-.079.038,13.907,13.907,0,0,0-.615,1.264,18.443,18.443,0,0,0-5.551,0,12.733,12.733,0,0,0-.625-1.264.077.077,0,0,0-.079-.038,19.981,19.981,0,0,0-4.942,1.533.07.07,0,0,0-.033.028,20.493,20.493,0,0,0-3.587,13.819.085.085,0,0,0,.032.057,20.139,20.139,0,0,0,6.063,3.065.08.08,0,0,0,.085-.028,14.374,14.374,0,0,0,1.24-2.018.077.077,0,0,0-.042-.107,13.234,13.234,0,0,1-1.894-.9.078.078,0,0,1-.008-.129c.128-.1.255-.195.376-.295a.076.076,0,0,1,.079-.011,14.359,14.359,0,0,0,12.2,0,.076.076,0,0,1,.079.01c.122.1.249.2.377.3a.078.078,0,0,1-.007.129,12.4,12.4,0,0,1-1.894.9.079.079,0,0,0-.042.108,16.141,16.141,0,0,0,1.24,2.017.077.077,0,0,0,.085.029,20.083,20.083,0,0,0,6.072-3.065.079.079,0,0,0,.032-.056,20.356,20.356,0,0,0-3.59-13.819A.06.06,0,0,0,6972.913,4015.281Zm-12.44,11.089a2.463,2.463,0,0,1,0-4.894,2.463,2.463,0,0,1,0,4.894Zm8.068,0a2.463,2.463,0,0,1,0-4.894,2.463,2.463,0,0,1,0,4.894Z",
  fill: "#75808c"
})));

function SvgDiscordGrey2X(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordGrey2X);
export default __webpack_public_path__ + "static/media/discord-grey@2x.951eebaa51ac1357bc2066b1bf365c8e.svg";
export { ForwardRef as ReactComponent };